<template>
  <div id="surveys" class="panel">
    <div class="panel-block">
      <div class="container">
        <div class="level">
          <div class="level-left">
            <!-- <div class="level-item is-italic">
              <span class="databronnen">Databronnen:</span>
            </div>
            <div class="level-item">
              <span class="field">
                <input
                  class="is-checkradio"
                  id="parking"
                  value="parking"
                  type="checkbox"
                  v-model="selectedDataSources">
                <label for="parking">Parkeerdata</label>
                <input
                  class="is-checkradio"
                  id="temperature"
                  value="temperature"
                  type="checkbox"
                  v-model="selectedDataSources">
                <label for="temperature">Temperatuur</label>
              </span>
            </div> -->
          </div>
          <div class="level-right">
            <div class="level-item is-italic" v-if="currentDate">
              Geselecteerde datum en tijd: {{ currentDate }}
            </div>
          </div>
        </div>
        <LineChart
          class="main-chart"
          :chartData="timeSeriesChartData"
          :options="timeSeriesChartOptions"
          :height="200"
        />
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import constants from "../../constants";
import { mapGetters } from "vuex";
import moment from "moment";
import BarChart from "./BarChart";
import LineChart from "./LineChart";

export default {
  name: "Surveys",
  components: {
    BarChart,
    LineChart
  },
  data() {
    return {
      selectedDataSources: ["parking", "temperature"],
      defaultChartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        onLineDraw: item => this.onLineDraw(item),
        onClick: (evt, item) => {
          if (item.length > 0) {
            this.onChartItemClick(item);
          }
        },
        legend: {
          display: true,
          position: "right",
          usePointStyle: false,
          labels: { boxWidth: 0 }
        }
      }
    };
  },
  computed: {
    ...mapGetters({
      navigationActiveTab: "navigationActiveTab",
      studies: "dataExperienceSamplingStudies",
      dataFilterStartDate: "dataFilterStartDate",
      dataFilterEndDate: "dataFilterEndDate"
    }),
    timeSeriesChartData: function() {
      return this.$store.getters.dataTimeSeries.data;
    },
    timeSeriesChartOptions: function() {
      return {
        ...this.defaultChartOptions,
        scales: this.$store.getters.dataTimeSeries.options.scales
      };
    },
    currentDate: {
      get() {
        if (this.$store.getters.dataCurrentDate) {
          return moment(this.$store.getters.dataCurrentDate).format(
            "YYYY-MM-DD / HH:mm "
          );
        }
        return "";
      },
      set(value) {
        this.$store.commit("setDataCurrentDate", value);
      }
    }
  },
  watch: {
    navigationActiveTab(val) {
      this.$store.dispatch("fetchWeatherTimeSeries", {
        startDate: this.$store.getters.dataFilterStartDate,
        endDate: this.$store.getters.dataFilterEndDate,
        location: val.name.toLowerCase()
      });
    },
    dataFilterStartDate(val) {
      let payload = {
        startDate: val,
        endDate: this.$store.getters.dataFilterEndDate,
        location: this.navigationActiveTab.name.toLowerCase()
      };
      this.updateWeather(payload);
      this.updateParking(payload);
      this.fetchTravelTimeTimeSeries();
      this.fetchTravelIntensityTimeSeries();
    },
    dataFilterEndDate(val) {
      let payload = {
        startDate: this.$store.getters.dataFilterStartDate,
        endDate: val,
        location: this.navigationActiveTab.name.toLowerCase()
      };
      this.updateWeather(payload);
      this.updateParking(payload);
      this.fetchTravelTimeTimeSeries();
      this.fetchTravelIntensityTimeSeries();
    }
  },
  methods: {
    updateWeather(payload) {
      this.$store.dispatch("fetchWeatherTimeSeries", payload);
    },
    updateParking(payload) {
      this.$store.dispatch("fetchParkingTimeSeries", payload);
    },
    fetchTravelTimeTimeSeries() {
      this.$store.dispatch("fetchTravelTimeTimeSeries");
    },
    fetchTravelIntensityTimeSeries() {
      this.$store.dispatch("fetchTravelIntensityTimeSeries");
    },
    onChartItemClick(item) {
      this.currentDate = this.$store.getters.dataTimeSeries.data.labels[
        item[0]._index
      ];
      this.$store.dispatch("fetchWeatherOnDate", {
        onDate: this.$store.getters.dataTimeSeries.data.labels[item[0]._index],
        location: this.navigationActiveTab.name.toLowerCase()
      });
    },
    onLineDraw(item) {
      this.currentDate = item;
      this.$store.dispatch("fetchWeatherOnDate", {
        onDate: item,
        location: this.navigationActiveTab.name.toLowerCase()
      });
      this.$store.commit("setMapDataParkingOnDate", { onDate: item });
      // Set the travel time
      const traveltimeseries = this.$store.getters.dataTravelTimeTimeSeries;
      let selectedTimeInstant = moment(item).unix();
      const timeseries = traveltimeseries[selectedTimeInstant * 1000];
      if (timeseries) {
        for (let i = 0; i < timeseries.length; i++) {
          this.$store.commit("setTravelTime", timeseries[i]);
        }
      }
      // Set the travel intensity
      const travelintensityseries = this.$store.getters
        .dataTravelIntensityTimeSeries;
      const intensityts = travelintensityseries[selectedTimeInstant * 1000];
      // console.log(intensityts)
      // console.log(this.$store.getters.mapLayerTrafficIntensity)
      if (intensityts) {
        let fc = {
          ...this.$store.getters.mapLayerTrafficIntensity.source.data
        };
        // eslint-disable-next-line
        // console.log(fc);
        for (let i = 0; i < fc.features.length; i++) {
          let found = intensityts.find(f => f.id === fc.features[i].id);
          if (found) {
            fc.features[i].properties = found.properties;
          }
        }
        this.$store.commit("setDataTrafficIntensityTimeseries", fc);
      }
    }
  }
};
</script>

<style scoped>
.studies {
  height: 190px;
  padding-left: 20px;
}

.studies ul {
  list-style-type: disc;
  padding-left: 24px;
  padding-top: 0;
}
.active-study {
  color: rgba(34, 208, 178, 1);
}
.no-survey {
  font-weight: bold;
}
.field label {
  padding-right: 10px;
}
.databronnen {
  left: -24px;
  position: relative;
  font-style: italic;
}
.level {
  margin-bottom: 10px;
}
</style>
